module.exports = __webpack_public_path__ + "static/atlaskit-datepicker-error-879f411a7f979bff1e1be15d35b86b0c.png";